import ConfigProvider from "antd/es/config-provider";
import localeEN from "antd/lib/locale/en_US";
import localeFr from "antd/lib/locale/fr_FR";
import i18n from "config/i18n/i18n";
import { routes } from "config/routes";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";

import "@neonumy/neonumy-ui/lib/index.css";
import "./resources/styles/styles.less";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(weekday);

function App(): JSX.Element {
  return (
    <I18nextProvider i18n={i18n}>
      <ConfigProvider locale={i18n.language === "en" ? localeEN : localeFr}>
        <RouterProvider router={routes} />
      </ConfigProvider>
    </I18nextProvider>
  );
}

export default App;
